import React, { Component } from "react";
import ReactDOM from 'react-dom';
import MyDossierFileItem from "./MyDossierFileItem";
import axios from "axios"
import Pagination from "./Pagination";
import { LangContext } from "../LangContext.jsx";
class MyDossierFilesPanel extends Component {
  static contextType = LangContext;

  constructor(props) {
    super(props);
    this.state = {
      filters: {},
      searchActive: false,
      pagination: { page: 1 },
      files: { data: [], total: 0 },
    };
  }

  getFiles = async () => {
    const { dossier_id } = this.props;
    const request = await axios.get(`/api/my_dossiers/${dossier_id}/files`)
    this.setState({ files: request.data })
  }

  getFilteredFiles = async () => {
    const { dossier_id } = this.props;
    const { filters } = this.state;
    const mixFilter = { ...filters };
    const query = new URLSearchParams();
    Object.keys(mixFilter).forEach(key => {
      if(mixFilter[key] != "" && mixFilter[key] != 1){
        query.append(key, mixFilter[key])
      }
    });
    const qs = query.toString()
    if(qs !== ""){
      const request = await axios.get(`/api/my_dossiers/${dossier_id}/files?${qs}`)
      this.setState({ files: request.data, searchActive: true })
    } else {
      this.setState({ searchActive: false })
      this.getFiles()
    }
  }

  handleFiltering = (e) => {
    this.setState((prev) => ({ filters: { ...prev.filters, [e.target.name]: e.target.value } }))
  }

  updateCurrentPage = (tab, page) => {
    this.setState((prev) => ({ pagination: { ...prev.pagination, page } }))
  }

  componentDidMount() {
    this.getFiles()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filters !== this.state.filters || prevState.pagination.page !== this.state.pagination.page) {
      this.getFilteredFiles()
    }
  }

  render() {
    const { files, pagination } = this.state;
    return (
    <>
      <h5 className="text-dark font-weight-bold my-5">
        <small className="text-muted font-weight-bold">Resultados de la búsqueda:</small>
        &nbsp; {files.total} &nbsp;
        <small className="text-muted font-weight-bold">documentos encontrados</small>
      </h5>

      <div className="card card-custom my-5">
        <div className="card-body">
          <table className="table table-borderless m-0 table-valign">
            <thead>
              <tr>
                <th colSpan="2">Nombre del archivo</th>
                <th>Fecha de Actualización</th>
              </tr>
            </thead>
            <tbody> 
              {files.data.map((file, idx) => (
                <MyDossierFileItem
                  key={idx}
                  file={file}
                />
              ))}
            </tbody>
          </table>

          {files.total > 10 &&
            <Pagination
              updateCurrentPage={this.updateCurrentPage}
              currentPage={pagination.page}
              totalFiles={files.total}
              split={10} />
          }
        </div>
      </div>
    </>
  )
  }
}

export default MyDossierFilesPanel;

if (document.getElementById('MyDossierFilesPanel')) {
    ReactDOM.render(<MyDossierFilesPanel />, document.getElementById('MyDossierFilesPanel'));
}

